module.exports = __webpack_public_path__ + "static/productivity-27bba8cdb38575166a29a33daddf2a48.gif";